import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';

import Display from '../common/Display';

const list = [
  `Proactive tools to cut down on customer inquiries with tools like
auto account updater, automatic club emails, and intuitive
interfaces`,
  `Commerce7's systems intuitive search, data displays, and reports put
the information you need at your fingertips`,
  `Commerce7 was built for speed. Process 1000 club members in 90
seconds and, on average, APIs respond in less than 100 milliseconds`
];

const StreamlineWorkflows = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "home/streamlined-workflows.png" }) {
        ...displayImageFragment
      }
    }
  `);

  return (
    <Display
      title="Streamlined workflows"
      content="Automate your workflows and spend your time on what matters most."
      list={list}
      image={data.image}
      cta={{
        label: 'View our solutions',
        to: '/solutions',
        color: 'var(--blue-base);'
      }}
    />
  );
};

export default StreamlineWorkflows;
